import{a as r}from"./chunk-RUHQUI2Z.js";import{a as e}from"./chunk-RAAYCPUM.js";function u(...n){return e(t,n)}function t(n){if(n.length!==0)return r(n)/n.length}export{u as a};
